/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Nav_PromptInputs */

const en_road_dude_nav_prompt = /** @type {(inputs: Road_Dude_Nav_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt template`)
};

const zh_road_dude_nav_prompt = /** @type {(inputs: Road_Dude_Nav_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提示词模板`)
};

/**
* | output |
* | --- |
* | "Prompt template" |
*
* @param {Road_Dude_Nav_PromptInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_nav_prompt = /** @type {((inputs?: Road_Dude_Nav_PromptInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Nav_PromptInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_nav_prompt(inputs)
	return zh_road_dude_nav_prompt(inputs)
});
export { road_dude_nav_prompt as "road_dude.nav.prompt" }